import { render, staticRenderFns } from "./material-pricing.vue?vue&type=template&id=51a43faf&"
import script from "./material-pricing.vue?vue&type=script&lang=js&"
export * from "./material-pricing.vue?vue&type=script&lang=js&"
import style0 from "./material-pricing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a43faf')) {
      api.createRecord('51a43faf', component.options)
    } else {
      api.reload('51a43faf', component.options)
    }
    module.hot.accept("./material-pricing.vue?vue&type=template&id=51a43faf&", function () {
      api.rerender('51a43faf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Inshape/Admin/Materials/AddMaterial/PricingComponent/material-pricing.vue"
export default component.exports